import Axios from '@/components/api/axios.js'
/**********************************************************************************
 * 操作树，操作组的上一级
 **********************************************************************************/
export default {
	addQueueGroup: (name, isPublic, success, failure) => {
		Axios.post('/queueGroup/addQueueGroup.do', {
			name,
			isPublic
		}, success, failure)
	},
	deleteQueueGroupById: (pkid, success, failure) => {
		Axios.post('/queueGroup/deleteQueueGroupById.do', {
			pkid
		}, success, failure)
	},
	editQueueGroup: (pkid, name, success, failure) => {
		Axios.post('/queueGroup/editQueueGroup.do', {
			pkid,
			name,
		}, success, failure)
	},
	addQueueGroupItem: (queueGroupId, operationGroupNo, operationNo, success, failure) => {
		Axios.post('/queueGroup/addQueueGroupItem.do', {
			queueGroupId,
			operationGroupNo,
			operationNo
		}, success, failure)
	},
	updateQueueGroupItem: (pkids, queueGroupIds, operationGroupNos, operationNos, success, failure) => {
		Axios.post('/queueGroup/updateQueueGroupItem.do', {
			pkids,
			queueGroupIds,
			operationGroupNos,
			operationNos
		}, success, failure)
	},
	deleteQueueGroupItem: (pkid, success, failure) => {
		Axios.post('/queueGroup/deleteQueueGroupItem.do', {
			pkid
		}, success, failure)
	},
	searchQueueGroupTree: (success, failure) => {
		Axios.post('/queueGroup/searchQueueGroupTree.do', {}, success, failure)
	},
	addQueueGroupItemByDeviceNos: (queueGroupId, deviceNos, apptype, success, failure) => {
		Axios.post('/queueGroup/addQueueGroupItemByDeviceNos.do', {
			queueGroupId,
			deviceNos,
			apptype,
		}, success, failure)
	},
	searchQueueGroupTreeByPkid: (pkid, success, failure) => {
		Axios.post('/queueGroup/searchQueueGroupTreeByPkid.do', {
			pkid,
		}, success, failure)
	},
	addJavaQueueItemByVariableNameAndValue: (queueGroupId, commandArray, success, failure) => {
		Axios.post('/queueGroup/addJavaQueueItemByVariableNameAndValue.do', {
			queueGroupId,
			commandArray
		}, success, failure)
	},
	deleteQueueGroupJavaItem: (queueGroupId, deviceId, success, failure) => {
		Axios.post('/queueGroup/deleteQueueGroupJavaItem.do', {
			queueGroupId,
			deviceId
		}, success, failure)
	},
	updateQueueGroupJavaItem: (queueGroupId, deviceId, command, success, failure) => {
		Axios.post('/queueGroup/updateQueueGroupJavaItem.do', {
			queueGroupId,
			deviceId,
			command,
		}, success, failure)
	},
	sendQueueGroup: (pkid, success, failure) => {
		Axios.post('/queueGroup/sendQueueGroup.do', {
			pkid
		}, success, failure)
	},
}
